import { userConstants } from './../constants/user.constants';

const initialState = {};

export function InstitueDetails(state = initialState, action) {
  
  switch (action.type) {
    case userConstants.UPDATEINSTITUTEDETAILS_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.UPDATEINSTITUTEDETAILS_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.UPDATEINSTITUTEDETAILS_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}